import { initializeApp } from "firebase/app";
import {
  getFirestore,
  connectFirestoreEmulator,
  enableIndexedDbPersistence,
  doc,
  getDoc,
  updateDoc,
  setDoc,
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { firebaseConfig } from "firebaseConfig";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, connectDatabaseEmulator } from "firebase/database";


const isDevMode = window.location.hostname === "localhost";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const messaging = getMessaging(app);
const analytics = getAnalytics(app);
const rtdb = getDatabase(app, "https://cheapgptchat-default-rtdb.europe-west1.firebasedatabase.app/");
// const rtdb = getDatabase(app);
const functions = getFunctions(app);
const storage = getStorage(app, firebaseConfig.storageBucket);

const VAPID_KEY =
  "BNTSf2AgN3WjHQL58IRoMcdoDSjiKAsdoTkGgi63lyhd8u6uO40T__xexoiBgbRl3ao_g41HUVKYKnoxlviHCqU";

export const requestPermissionAndGenerateToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    return await getAndStoreToken();
  }
};

export const getAndStoreToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
    });
    if (currentToken) {
      await storeToken(currentToken);
    }
    return currentToken;
  } catch (error) {
    console.log('An error occurred while retrieving token:', error);
    return null;
  }
};

const storeToken = async (token) => {
  const tokenRef = doc(db, "vapidTokens", auth.currentUser.uid);
  const tokenSnap = await getDoc(tokenRef);
  if (tokenSnap.exists()) {
    await updateDoc(tokenRef, {
      tokens: [...new Set([...tokenSnap.data().tokens, token])],
    });
  } else {
    await setDoc(tokenRef, {
      tokens: [token],
    });
  }
};

if (isDevMode) {
  // Setup emulator usage
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  // connectDatabaseEmulator(rtdb, "localhost", 9000); 
  // connectStorageEmulator(storage, "localhost", 9199);
  // connectAuthEmulator(auth, "http://localhost:9099");
}

export { auth, db, functions, storage, messaging, analytics, rtdb };
